import React from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import * as Styles from './DialogModalStyles';

type Props = {
  show: boolean;
  children?: React.ReactNode;
  modalStyle?: React.CSSProperties;
};

const DialogModal: React.FC<Props> = ({ show, children = <div />, modalStyle = {} }: Props) => {
  const Modal = (
    <CSSTransition in={show} classNames="fadeInOut" timeout={300} unmountOnExit>
      <Styles.Overlay>
        <Styles.Modal style={modalStyle}>{children}</Styles.Modal>
      </Styles.Overlay>
    </CSSTransition>
  );

  if (process.env.NODE_ENV === 'test') return Modal;

  return createPortal(Modal, document.getElementById('dialog-modal')!);
};

export default DialogModal;
